import EnterprisePlansCard from '@/components/global-admin/pricing/EnterprisePlansCard';

export default function EnterprisePlansPage() {
  return (
    <div className="space-y-6" data-testid="enterprise-plans-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Enterprise plans</h2>
        <p className="text-muted-foreground">
          The plans you can send an enterprise client, what each one unlocks, and what it costs.
          A plan is never priced below small business.
        </p>
      </div>

      <EnterprisePlansCard />
    </div>
  );
}
